import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
//import { unregister } from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');
const app = (
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

if (rootElement.hasChildNodes()) {
    ReactDOM.hydrate(app, rootElement);
} else {
    ReactDOM.render(app, rootElement);
}
//registerServiceWorker();
//unregister();



// WEBPACK FOOTER //
// ./src/index.js